export const globalPubSubChannel = '78dd4597f40ba43c36e0ad553d47e1b64dedc62fc89a4f0d28d8b2ce3624f06b';
